export default __webpack_public_path__ + "6c9fac0ed313c805259f29094caa5aaf.png";